(function () {
  "use strict";

  mfCustomCertificate.$inject = ['mtypes'];
  mfCustomCertificateField.$inject = ['mtypes'];
  angular
    .module('trainerWebApp.directives')
    .directive('mfCustomCertificate', mfCustomCertificate)
    .directive('mfCustomCertificateField', mfCustomCertificateField);

  function mfCustomCertificate(mtypes) {
    return {
      restrict: 'A',
      link: function (scope, elem, attrs) {
        var container = elem.find('.cc-container');
        var layout = elem.find('.cc-layout');
        var scale = 1;

        function scaleLayout() {
          var cH = container.height();
          var cW = container.width();

          layout.css('width', '11In');
          layout.css('height', '8.5In');

          var lH = layout.height();
          var lW = layout.width();

          var scaleH = cH / lH;
          var scaleW = cW / lW;

          scale = scaleH > scaleW ? scaleW : scaleH;

          layout.css('width', lW * scale);
          layout.css('height', lH * scale);

          resizeInputs(scale);

          scope.initialized = true;

          scope.resizeContainers(scale);

          if (!scope.$root.$$phase)
            scope.$apply();
        }

        scope.$watch('bottomFieldContainerStyle', function () {
          resizeInputs(1);
        });

        function resizeInputs(scale) {
          var inputContainerW = (parseFloat(angular.element('.cc-bottom-field-container').css('width')) / 5 * 0.9) * scale;
          var input = angular.element('.cc-bottom-field-container .cc-field-input');
          var paddingL = parseFloat(input.css('padding-left') || 0);
          var paddingR = parseFloat(input.css('padding-right') || 0);
          var borderW = 2;
          var inputW = (inputContainerW - paddingL - paddingR - borderW);
          input.css('width', Math.floor(inputW));
        }

        scope.$on("resized", function () {
          scaleLayout();
        });

        var traineeSearchInput = angular.element('#trainee-search-input');

        traineeSearchInput.bind('select2-selecting', function () {
          traineeSearchInput.select2('val', '');
        });


      }
    }
  }

  function mfCustomCertificateField(mtypes) {
    return {
      restrict: 'E',
      transclude: false,
      templateUrl: 'pages/certificate/customCertificateField.html',
      replace: true,
      scope: {
        ccType: '=',
        ccText: '=',
        ccShowWarning: '=',
        ccFields: '=',
        ccChange: '&'
      },
      controller: ['$scope', function ($scope) {

        $scope.isOpen = false;

        $scope.showSelect2 = function () {
          return $scope.ccType != mtypes.customCertificateField.textField || $scope.isOpen;
        };

        $scope.showTextField = function () {
          return $scope.ccType == mtypes.customCertificateField.textField && !$scope.isOpen;
        };

        $scope.showWarning = function () {
          return $scope.ccShowWarning;
        };

        $scope.changeTooltip = function () {
          if ($scope.ccType == mtypes.customCertificateField.textField) {
            $scope.fieldTooltip = $scope.ccText;
          } else {
            var field = _.find($scope.ccFields, function (f) {
              return f.type == $scope.ccType;
            });
            $scope.fieldTooltip = field ? field.name : "";
          }
        };

        $scope.fieldTooltip = "";
      }],
      link: function (scope, element, attrs, controller) {

        var select2 = element.find('.cc-field-select');
        var arrow = element.find('.cc-select2-arrow');
        var input = element.find('.cc-field-input');

        arrow.bind('click', function () {

          scope.$apply(function () {
            scope.isOpen = true;
          });

          select2.select2('open');
        });

        scope.$watch('ccType', function (val, old) {
          if (val === old || !val && !old) {
            return;
          }

          if (val == mtypes.customCertificateField.textField) {
            input.focus();
          }

          scope.changeTooltip();
          scope.ccChange();
        });

        scope.$watch('ccText', function (val, old) {
          if (val === old) {
            return;
          }

          scope.changeTooltip();
          scope.ccChange();
        });

        select2.bind('select2-close', function () {
          scope.$apply(function () {
            scope.isOpen = false;
          });
        });
      }
    }
  }

})();
